import Vue from 'vue'
import {
  Vuetify,
  VApp,
  VNavigationDrawer,
  VFooter,
  VList,
  VBtn,
  VIcon,
  VGrid,
  VToolbar,
  VMenu,
  VAvatar,
  transitions
} from 'vuetify'
import { Scroll } from 'vuetify/es5/directives'
import '@/stylus/main.styl'

Vue.use(Vuetify, {
  components: {
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VGrid,
    VToolbar,
    VMenu,
    VAvatar,
    transitions
  },
  directives: {
    Scroll
  },
  theme: {
    primary: '#A8201A',
    secondary: '#CC5803',
    accent: '#828A95',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  },
  iconfont: 'md',
})
